export const getIsLeftMenuOpened = ({ ui }) => ui.isLeftMenuOpened;
